export const cancerConsultationCreateTranslations = {
    en: {
        submitSuccess: "Cancer screening saved successfully!",
        submitFailed: "Failed to save cancer screening!",
        submitting: "Submitting...",
        submit: "Save Screening Details",

        patientInformation: "Patient Information",
        tokenNo: "Token No",
        tokenPlaceholder: "Search Token No e.g. 00005",
        beneficiaryName: "Beneficiary Name",
        fetchOpdFailed: "Failed to fetch OPD numbers!",
        gender: "Gender",
        male: "Male",
        female: "Female",
        other: "Other",
        notAvailable: "N/A",
        genderMissing: "Gender not available for this beneficiary — male screening sections will be shown by default.",

        commonSections: "Common History",
        maleSpecific: "Male Cancer Screening",
        femaleSpecific: "Female Cancer Screening",
        examTitle: "Examination & Tests",

        yes: "Yes",
        no: "No",

        maritalStatus: "Marital Status",
        selectMaritalStatus: "Select marital status",

        assessmentCard: "Risk Assessment & Referral",
        riskLevel: "Risk Level",
        referredHospital: "Referred Hospital",
        referredHospitalPlaceholder: "Enter hospital name if referred",
        finalRemark: "Final Remark",
        finalRemarkPlaceholder: "Doctor's final remark / overall observation",
    },
    mr: {
        submitSuccess: "कॅन्सर तपासणी यशस्वीरित्या जतन झाली!",
        submitFailed: "कॅन्सर तपासणी जतन करण्यात अयशस्वी!",
        submitting: "सबमिट करत आहे...",
        submit: "तपासणी तपशील जतन करा",

        patientInformation: "रुग्ण माहिती",
        tokenNo: "टोकन क्रमांक",
        tokenPlaceholder: "टोकन क्रमांक शोधा उदा. 00005",
        beneficiaryName: "लाभार्थीचे नाव",
        fetchOpdFailed: "ओपीडी क्रमांक आणण्यात अयशस्वी!",
        gender: "लिंग",
        male: "पुरुष",
        female: "स्त्री",
        other: "इतर",
        notAvailable: "उपलब्ध नाही",
        genderMissing: "या लाभार्थीसाठी लिंग उपलब्ध नाही — डीफॉल्ट म्हणून पुरुष तपासणी विभाग दर्शविले जातील.",

        commonSections: "सामान्य इतिहास",
        maleSpecific: "पुरुष कॅन्सर तपासणी",
        femaleSpecific: "स्त्री कॅन्सर तपासणी",
        examTitle: "तपासणी आणि चाचण्या",

        yes: "होय",
        no: "नाही",

        maritalStatus: "वैवाहिक स्थिती",
        selectMaritalStatus: "वैवाहिक स्थिती निवडा",

        assessmentCard: "धोका मूल्यांकन व संदर्भ",
        riskLevel: "धोक्याची पातळी",
        referredHospital: "संदर्भित रुग्णालय",
        referredHospitalPlaceholder: "संदर्भित केल्यास रुग्णालयाचे नाव टाका",
        finalRemark: "अंतिम नोंद",
        finalRemarkPlaceholder: "डॉक्टरांची अंतिम नोंद / एकूण निरीक्षण",
    },
};
